import angular from 'angular';

/**
 * Filter to override angular-filter groupBy with improved performance
 * @param {Array} collection - List of object to filter
 * @param {String} key - String to group by, uses dot separators for sub properties
 * @returns {Object} - Grouped object by key
 */
export default function GroupByCustom($parse) {
    return memoize(function groupByFilter(collection, key) {
        if (!angular.isObject(collection) || angular.isUndefined(key)) {
            return collection;
        }

        const getter = $parse(key);
        return collection.reduce((result, item) => {
            const itemKey = getter(item);
            result[itemKey] = result[itemKey] || [];
            result[itemKey].push(item);
            return result;
        }, {});
    });
}
GroupByCustom.$inject = ['$parse'];

function memoize(func) {
    const cache = {};
    const slice = Array.prototype.slice;

    return function (...rest) {
        const args = slice.call(rest);
        const argString = JSON.stringify(args);

        if (argString in cache) {
            return cache[argString];
        }
        return (cache[argString] = func.apply(this, args));
    };
}
